const local = {
  apiUrl: 'http://localhost:8000/api',
  socketUrl: 'http://localhost:8000'
};

const staging = {
  apiUrl: 'https://dev.getsortedservices.com/api',
  socketUrl: 'http://dev.getsortedservices.com:9234'
};

const production = {
  apiUrl: 'https://getsortedservices.com/api',
  socketUrl: 'https://getsortedservices.com'
};

let settings;

if (process.env.REACT_APP_ENV === 'local') settings = local;
else if (process.env.REACT_APP_ENV === 'staging') settings = staging;
else if (process.env.REACT_APP_ENV === 'production') settings = production;
else settings = local;

export const apiUrl = settings.apiUrl;
export const socketUrl = settings.socketUrl;
